<template>
  <div
    class="slds-dropdown-trigger slds-dropdown-trigger_click slds-is-open"
    v-click-outside="{callback: closeEvent, enable: true}">
    <button
      aria-haspopup="true"
      class="slds-button slds-button_icon slds-button_icon-border-filled"
      title="Show More"
      :disabled="disabled"
      @click="open = !open">
      <svg class="slds-button__icon" aria-hidden="true">
        <use xlink:href="../../assets/symbols.svg#down" />
      </svg>
    </button>
    <div
      :class="`slds-dropdown slds-dropdown_${position}`"
      v-if="open">
      <ul class="slds-dropdown__list" role="menu">
        <li
          class="slds-dropdown__item" role="presentation"
          v-for="(option, index) in localOptions"
          :key="option.value">
          <a href="javascript:void(0);" role="menuitem" :tabindex="index" @click="select(option.value)">
            <span class="slds-truncate" :title="option.label">
              <svg
                class="slds-icon slds-icon_x-small slds-icon-text-default slds-m-right_x-small"
                aria-hidden="true" v-if="!hideCheck">
                  <use
                    v-if="option.value === localValue"
                    xlink:href="../../assets/symbols.svg#check"></use>
              </svg>
              {{option.label}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  created () {
    this.localValue = this.value
    this.localOptions = this.options.map(option => {
      return {
        label: this.labelsPrefix ? this.$t(`${this.labelsPrefix}.${option}`) : option,
        value: option
      }
    })
  },
  data () {
    return {
      localOptions: '',
      localValue: '',
      open: false
    }
  },
  methods: {
    closeEvent () {
      if (this.open) {
        this.open = false
      }
    },
    select (option) {
      this.$emit('select', { value: option })
      this.open = false
    }
  },
  props: {
    disabled: Boolean,
    hideCheck: Boolean,
    labelsPrefix: String,
    options: Array,
    position: {
      type: String,
      default: 'left'
    },
    value: String
  },
  watch: {
    value (value) {
      this.localValue = value
    }
  }
}
</script>
<style lang="scss" scoped>
.slds-dropdown-trigger {
  display: inline-flex !important;
  margin-left: 10px;
}
</style>
